import React, { Component } from 'react'
import { meta } from 'helpers/decorators'
import { apiApiKeys } from 'helpers/decorators/api'
import PropTypes from 'prop-types'
import { ApiKeyList } from 'containers/misc'
import { compose } from 'recompose'
import { Button } from 'components/misc'

const enhance = compose(
  meta({
    title: 'Api Keys',
    intlKey: 'pageTitle.apiKeys',
  }),
  apiApiKeys()
)

class OrganizationApiKeys extends Component {
  static propTypes = {
    getOrganizationApiKeys: PropTypes.func.isRequired,
    deleteApiKey: PropTypes.func.isRequired,
    apiKeys: PropTypes.object.isRequired,
    addApiKey: PropTypes.func.isRequired,
  }

  static defaultProps = {
    apiKeysList: []
  }

  componentDidMount () {
    const organizationId = this.props.params.id

    this.props.getOrganizationApiKeys(organizationId)
  }

  handleAddKey = async () => {
    const organizationId = this.props.params.id

    await this.props.addApiKey(organizationId)
    this.handleRefresh()
  }

  handleRefresh = () => {
    const organizationId = this.props.params.id

    if (organizationId && !this.props.apiKeys.loading) {
      this.props.getOrganizationApiKeys(organizationId)
    }
  };

  render () {
    const { apiKeys, deleteApiKey } = this.props

    const organizationId = Number(this.props.params.id)

    return (
      <div>
        <div className="text--right">
          <Button
            intlKey="button.add_key"
            onClick={this.handleAddKey}
          >
            Add key
          </Button>
        </div>
        <ApiKeyList organizationId={organizationId}
                    apiKeys={apiKeys.list}
                    deleteApiKey={deleteApiKey}
                    handleRefresh={this.handleRefresh}
        />
      </div>
    )
  }
}

export default enhance(OrganizationApiKeys)
